export default __webpack_public_path__ + "static/media/aiPoster.d85db228.jpg";